import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { evidenceOfRegulationDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const EvidenceOfRegulationFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={evidenceOfRegulationDocumentTypesArray}
        placeholder="Select an evidence of regulation document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default EvidenceOfRegulationFormValues;
